// css
import '../css/main.scss';

// polyfills
import 'babel-polyfill';
import 'element-closest';
import './polyfill';

import './windowExports';
//
// // source
import './web';
import './configureWeb';
import './configurePartialUpdate';
// import './configureTurbolinks';



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/index.js